import { jsxs as p, jsx as u } from "react/jsx-runtime";
import { c as a } from "./index-65016bfa.mjs";
import l, { css as B } from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as I } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Button as d } from "./button.js";
import { Icon as f } from "./icon.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "@fcamna/shared-icons";
const h = l(d)`
  &.IconButton {
    ${({
  theme: {
    components: { iconButton: t }
  }
}) => B(t.IconButton)};
  }
`, y = {
  tertiary: "text",
  ghost: "text",
  secondary: "outline",
  primary: "solid"
}, C = ({
  size: t = "medium",
  color: i = "default",
  variant: o = "primary",
  icon: n,
  isDisabled: r = !1,
  iconName: m,
  className: s,
  ...e
}) => {
  const c = I({ label: "Icon Button" });
  return /* @__PURE__ */ p(
    h,
    {
      ...c,
      ...e,
      isDisabled: r,
      className: a([
        "IconButton",
        `IconButton--${t}`,
        `IconButton--${i}`,
        `IconButton--${o}`,
        { "IconButton--disabled": r },
        s
      ]),
      variant: y[o] || o,
      children: [
        /* @__PURE__ */ u(
          f,
          {
            className: "IconButton__icon",
            name: m,
            size: "m",
            height: "100%",
            width: "100%"
          }
        ),
        !!n && !m && n
      ]
    }
  );
};
export {
  C as IconButton
};
